<template>
  <div class="boxbgcolor finance inspector-arrears-statistics">
    <!--左侧树形索引-->
    <!-- <div class="left content-left">
      <AreaTree ref="table" v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div class="content-right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label>收费员:</label>
            <el-select filterable v-model="search.username" placeholder="请选择" clearable>
              <el-option
                v-for="item in chargeUserList"
                :key="item.username"
                :label="item.name"
                :value="item.username"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form-group">
            <span class="demonstration">月:</span>
            <el-date-picker
              v-model="value4"
              type="month"
              placeholder="选择月"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button @click="searchList" type="primary" :loading="loading" size="small">查询</el-button>
            </span>
            <span class="download_btn">
              <button
                @click="downloadExcel"
                type="button"
                class="btn btn-primary"
              >
                导出EXCEl
              </button>
            </span>
          </div>
        </form>
        <!-- <div class="download"></div> -->
      </div>
      <div class="show-date">{{ showDate.year }}年{{ showDate.month }}月</div>
      <div class="list">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-loading="loading"
        >
          <el-table-column
            fixed
            show-overflow-tooltip
            label="姓名"
            prop="name"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="1">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[0].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="2">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[1].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="3">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[2].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="4">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[3].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="5">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[4].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="6">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[5].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="7">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[6].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="8">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[7].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="9">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[8].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="10">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[9].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="11">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[10].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="12">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[11].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="13">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[12].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="14">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[13].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="15">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[14].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="16">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[15].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="17">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[16].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="18">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[17].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="19">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[18].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="20">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[19].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="21">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[20].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="22">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[21].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="23">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[22].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="24">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[23].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="25">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[24].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="26">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[25].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="27">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[26].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip label="28"> -->
          <el-table-column
            show-overflow-tooltip
            label="28"
            v-if="twentyEighthShow"
          >
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[27].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip label="29"> -->
          <el-table-column
            show-overflow-tooltip
            label="29"
            v-if="twentyNineShow"
          >
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[28].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip label="30"> -->
          <el-table-column show-overflow-tooltip label="30" v-if="thirtyShow">
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[29].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip label="31"> -->
          <el-table-column
            show-overflow-tooltip
            label="31"
            v-if="thirtyOneShow"
          >
            <template slot-scope="scope">{{
              scope.row.chargeDateList
                ? scope.row.chargeDateList[30].arrearsMoney
                : ""
            }}</template>
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip label="总计" prop="tollSum"></el-table-column> -->
        </el-table>
      </div>
      <Page
        v-on:pagination="receivePaginationData"
        v-bind:pageObj="pageObj"
      ></Page>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
// import AreaTree from "../../commons/areaTree";

import { getArrearsStatistics, chargeUserList } from "@/api/url";

import Page from "../../commons/page";

// import Refresh from "../commons/refresh.vue";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      twentyEighthShow: false,
      twentyNineShow: false,
      thirtyShow: false,
      thirtyOneShow: false,
      lastColumn: "",
      treeData: {
        parentId: "",
      },
      moduleName: "",
      search: {
        pageNumber: 1,
        pageSize: 10,
        year: "",
        month: "",
        dates: "",
        username:'',
      },
      value4: "",
      showDate: {
        year: "",
        month: "",
      },
      tableListData: [],
      tableListDataByDay: {},
      tableListDataExcel: {},
      tableListDataAll: {},
      pageObj: {},
      chargeUserList: [],
      loading: false,
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    // handleTreeClick: function(node, data) {
    //   this.search.month = "";
    //   this.search.year = "";
    //   this.search.dates = "";
    //   this.value4 = "";
    //   this.getDateNow();
    //   // if (node.type != "parking") {
    //   //   this.treeData.parentId = "";
    //   //   var pageObj = {
    //   //     curIndex: 1,
    //   //     rowsCount: 0
    //   //   };
    //   //   this.getPage(pageObj);
    //   //   this.tableListData = [];
    //   //   return;
    //   // } else {

    //     this.treeData.parentId = node.id;
    //     this.search.pageNumber = 1;
    //     this.tableList(this.search.pageNumber);
    //   // }
    // },
    tableList: function(curPage) {
      var _this = this;
      this.loading=true;
      this.reckonDate(this.value4);
      this.$get(getArrearsStatistics(), {
        username: this.search.username??null,
        date: this.search.dates,
        limit: this.search.pageSize,
        page: curPage,
        groupId:''
      }).then((data) => {
        if (data.status != 200) return this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.pageObj = { ...pageObj };
        // this.getPage(pageObj);
        const tempTableListData = data?.data?.rows ?? [];
        this.tableListData = tempTableListData.map((item) => {
          return this.formatMoney(item);
        });
        this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      })
    },
    formatMoney(item) {
      const mm = new Date().getMonth() + 1;
      const yy = new Date().getFullYear();
      let dd = 0;
      const chargeData = item?.chargeDateList ?? [];
      if (this.showDate.month < mm || this.showDate.year < yy) {
        dd = new Date(this.showDate.year, this.showDate.month, 0).getDate();
      } else if (this.showDate.month == mm && this.showDate.year === yy) {
        dd = new Date().getDate() - 1;
      }
      chargeData.map((it) => {
        const days = it.day.split("-")[2];
        if (days <= dd) {
          it.arrearsMoney = parseFloat(it.arrearsMoney).toFixed(2);
        } else {
          it.arrearsMoney = "";
        }
        return it;
      });
      item.chargeDateList = chargeData;
      return item;
    },
    downloadExcel() {
      // if (!this.treeData.parentId) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择集团，物业或道路"
      //   });
      //   return;
      // }
      this.reckonDate(this.value4);
      window.open(
        // `/api/parking/parkingOrders/arrearsStatisticsExport?date=${this.search.dates}&groupId=${this.treeData.parentId}`,
        `/api/parking/parkingOrders/arrearsStatisticsExport?date=${this.search.dates}&username=${this.search.username}&groupId=${this.treeData.parentId}`,
        "_self"
      )
    },
    searchList() {
     
        var _this = this;
        this.search.pageNumber = "1";

        // if (!this.treeData.parentId) {
        //   this.$message({
        //     type: "warning",
        //     message: "请选择道路"
        //   });
        //   return;
        // }
        if (this.value4) {
          this.monthHasDays(this.value4);
        }

        this.tableList(this.search.pageNumber);
        // this.tableListByDay();
     
    },
    reckonDate(v) {
      if (v) {
        let yy = v.getFullYear();
        let mm = v.getMonth() + 1;
        this.showDate.year = yy;
        this.showDate.month = mm;
        if (mm.toString().length <= 1) {
          this.search.month = "0" + mm;
        } else {
          this.search.month = mm;
        }
        this.search.year = yy;
      } else {
        var date = new Date();
        this.showDate.year = date.getFullYear();
        this.showDate.month = date.getMonth() + 1;
        this.search.year = date.getFullYear();
        let mm = date.getMonth() + 1;
        if (mm.toString().length <= 1) {
          this.search.month = "0" + mm;
        } else {
          this.search.month = mm;
        }
      }
      this.search.dates = this.search.year + "-" + this.search.month;
    },
    clearSearch: function() {},
    getDateNow() {
      var date = new Date();
      this.showDate.year = date.getFullYear();
      this.showDate.month = date.getMonth() + 1;
      this.monthHasDays(date);
    },
    //计算某年某月有多少天
    monthHasDays(d) {
      /* 获取当前月份 */
      var curMonth = d.getMonth();
      /* 生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
      d.setMonth(curMonth + 1);
      /* 将日期设置为0 */
      d.setDate(0);
      /* 返回当月的天数 */
      var days = d.getDate();
      switch (days) {
        case 28: {
          this.twentyEighthShow = true;
          this.twentyNineShow = false;
          this.thirtyShow = false;
          this.thirtyOneShow = false;
          this.lastColumn = 29;
          break;
        }
        case 29: {
          this.twentyEighthShow = true;
          this.twentyNineShow = true;
          this.thirtyShow = false;
          this.thirtyOneShow = false;
          this.lastColumn = 30;
          break;
        }
        case 30: {
          this.twentyEighthShow = true;
          this.twentyNineShow = true;
          this.thirtyShow = true;
          this.thirtyOneShow = false;
          this.lastColumn = 31;
          break;
        }
        default: {
          this.twentyEighthShow = true;
          this.twentyNineShow = true;
          this.thirtyShow = true;
          this.thirtyOneShow = true;
          this.lastColumn = 32;
          break;
        }
      }
    },
    //计算table每列总计
    getSummaries(param) {
      var _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[0] = "总计";
          return;
        }
        if (index == _this.lastColumn) {
          var lastC = _this.lastColumn;
          sums[lastC] = data.reduce(function(prev, cur) {
            return Number(cur.tollSum) + prev;
          }, 0);
        } else {
          const values = data.map((item) => {
            var columnIndex = "";
            if (String(index).length == 1) {
              columnIndex = "0" + index;
            } else {
              columnIndex = "" + index;
            }
            return Number(item.chargeDateMap[columnIndex]);
          });

          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            // sums[index] += " 元";
          } else {
            sums[index] = "";
          }
        }
      });
      return sums;
    },
    getChargeUser() {
      this.$get(chargeUserList() + "?isDeleted=0", {
        limit: 500,
        page: 1,
      }).then((res) => {
        if (res?.status !== 200) return this.$layer.msg(data.message);
        this.chargeUserList = res.data.rows;
      });
    },
  },
  computed: {
    /*...mapState({
				curIndex: state => state.page.curIndex,
				rowsCount: state => state.page.rowsCount
			}),*/

    ...mapGetters(["elements"]),
    // permiss(){
    // 	this.parklist_btn_add = this.elements['parklist:btn_add'];
    // 	this.parklist_btn_rule = this.elements['parklist:btn_rule'];
    // this.parklist_btn_pkset = this.elements['parklist:btn_pkset'];
    // this.parklist_btn_control = this.elements['parklist:btn_control'];
    // this.parklist_btn_person = this.elements['parklist:btn_person'];
    // this.parkset_btn_edit = this.elements['parklist:btn_edit'];
    // this.parklist_btn_remove=this.elements['parklist:btn_remove'];
    //console.log("parklist_btn_remove")
    //console.log(this.parklist_btn_remove)
    // }
    totalMoney() {
      var result = 0;
      if (this.tableListDataByDay) {
        let temp = this.tableListDataByDay;
        for (let key in temp) {
          result += parseFloat(temp[key]);
        }
      }
      return result.toFixed(2);
    },
  },
  components: {
    Page,

    // Refresh,
    // AreaTree
  },
  created: function() {
    // this.permiss;
  },
  mounted: function() {
    // this.tableList(this.pageNumber);
    // this.tableListByDay();
    this.getChargeUser();
    this.getDateNow();
    this.pageNumber = 1;
    this.tableList(this.pageNumber);
  },
  watch: {
    elements: {
      handler: function(val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;
  /* height:65px; */
  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
  overflow-x: auto;
  height: calc(100vh - 280px) !important;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
table {
  border: 1px solid #ccc;
}
table tr td {
  border: 1px solid #ccc;
}
.reload-container {
  display: inline-block;
  /* margin-top:8px; */
}
.reload {
  /* margin: 0px 10px; */
  cursor: pointer;
  color: #67c23a !important;
}
.reload:hover {
  color: rgb(45, 107, 15) !important;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}

</style>
<style>
.finance .el-table__footer td .cell {
  text-align: center;
  font-weight: bold;
  color: black;
}
.inspector-arrears-statistics .content-right {
  width: 100%;
}
</style>
